import React, { CSSProperties } from 'react';
import classNames from 'classnames';
import styles from './Wrapper.module.css';

export const Wrapper = ({
	theme = 'rounded',
	className,
	styleObj,
}: {
	theme?: string;
	className?: Record<string, boolean>;
	styleObj: CSSProperties;
}) => {
	if (!theme || theme === 'rounded') return null;

	return (
		<div
			className={classNames(styles.wrapper, {
				[styles.wrapperDark]: theme === 'dark',
				[styles.wrapperLight]: theme === 'light',
				...(className || {}),
			})}
			style={styleObj || {}}
		>
			<div className={styles.wrapperLightInner}>
				<div className={styles.wrapperLightTopBar}>
					<div className={styles.wrapperLightControls}>
						<span
							className={classNames(
								styles.wrapperLightControl,
								styles.wrapperLightControlClose
							)}
						></span>
						<span
							className={classNames(
								styles.wrapperLightControl,
								styles.wrapperLightControlMinimize
							)}
						></span>
						<span
							className={classNames(
								styles.wrapperLightControl,
								styles.wrapperLightControlExpand
							)}
						></span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Wrapper;
